












































import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { APP_CONFIG } from '@/config/app-config';

import Notification from './Notification.vue';

@Component({
    components: {
        'notification': Notification
    }
})
export default class AppHeader extends Vue {
    private isOpenMenuUser = false;
    private totalNotify = 0;

    get showMenuLeft() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get isToken() {
        return authProvider.isToken();
    }

    private onOpenUserMenu() {
        this.isOpenMenuUser = !this.isOpenMenuUser;
    }

    private onLogout() {
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }

    private onToggleMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', !this.showMenuLeft);
    }

    private getTotalNotification(total: number) {
        this.totalNotify = total;
    }
}
